import { apiSlice } from '../apiSlice'

export const productsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addProduct: builder.mutation({
      query: (data) => ({
        url: '/products/add-product',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: () => [
        { type: 'products' }, // Invalidate the products list (only if required)
      ],
    }),

    getProducts: builder.query({
      query: ({ page, size, productName }) =>
        `/products?pageNo=${page}&pageSize=${size}&productName=${productName}`,
      keepUnusedDataFor: 600,
      providesTags: (result) => {
        if (result?.content && Array.isArray(result.content)) {
          return [
            { type: 'products' }, // provides tag for Products list
            ...result.content.map(({ id }) => ({ type: 'product', id })), // provides tag for individual products
          ]
        }
        return [{ type: 'products' }] // fallback in case content is not available
      },
    }),

    getProduct: builder.query({
      query: (productId) => `/products/product/${productId}`,
      providesTags: (result, error, productId) => [
        { type: 'product', id: productId }, // Provides a tag for a single product
      ],
    }),

    updateProduct: builder.mutation({
      query: (data) => ({
        url: '/products/update-product',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'product', id }, // Invalidate the cache for the updated product
        { type: 'products' }, // Optionally invalidate the products list (only if required)
      ],
    }),

    deleteProduct: builder.mutation({
      query: (productId) => ({
        url: `/products/product/${productId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'products' }, // Optionally invalidate the products list (only if required)
      ],
    }),
  }),
})

export const {
  useGetProductQuery,
  useGetProductsQuery,
  useAddProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
} = productsApi
